import * as React from 'react';
import { SingleMeasurementTooltip } from '#components/charts/core/chart-tooltip/index.ts';
import { useIntl } from '@leagueplatform/locales';
import {
  LONG_WEEKDAY_DATE_FORMAT,
  useFormatDateByUserProfileLocation,
} from '@leagueplatform/web-common';
import { HealthMetricChart } from '#components/charts/types/chart.ts';
import { useLocaleMetricValueFormatter } from '#hooks/use-metric-value-formatter.ts';
import { CHART_VIEWS } from '#components/charts/constants/chart-views.ts';
import { MetricBarChart } from '../metric-bar-chart';

type FloorsClimbedBarChartProps = HealthMetricChart;

export function FloorsClimbedBarChart({
  data,
  view,
  type,
}: FloorsClimbedBarChartProps) {
  const { formatMessage, $tifelse } = useIntl();
  const formatDateWithUserProfileLocation =
    useFormatDateByUserProfileLocation();
  const { formatMetricValue } = useLocaleMetricValueFormatter();

  return (
    <MetricBarChart
      yMaxFromEnums={0}
      data={data}
      view={view}
      type={type}
      description={$tifelse(
        view === CHART_VIEWS.WEEKLY,
        'INSIGHT_CHART_FLOORS_CLIMBED_WEEK_DESCRIPTION',
        'INSIGHT_CHART_FLOORS_CLIMBED_MONTH_DESCRIPTION',
      )}
      axisLeftLabel={`${formatMessage({
        id: 'INSIGHT_CARD_HEADER_FLOORS_CLIMBED',
      })}`.toLocaleUpperCase()}
      ariaDatumLabel={(datum) =>
        formatMessage(
          { id: 'INSIGHT_CHART_FLOORS_CLIMBED_DATUM_LABEL' },
          {
            value: formatMetricValue(datum.value, type),
            date: formatDateWithUserProfileLocation(
              new Date(datum.timestamp),
              LONG_WEEKDAY_DATE_FORMAT,
            ),
          },
        )
      }
      renderTooltip={(datum) => (
        <SingleMeasurementTooltip
          title={formatMessage({ id: 'INSIGHT_CARD_HEADER_FLOORS_CLIMBED' })}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...datum}
        />
      )}
    />
  );
}
